const Projects = [
  // Star Trek: Infinite 
  {
     id: '1',

     // "Project Preview" data: used for the project overview button
     button: {
       previewImage: "img/projects/st_infinite/previewImage.jpg",          // URL to preview image
       techFramework: "C++, Clausewitz Engine (proprietary)",     // Technologies used
       title: "Star Trek: Infinite"                               // Project title
     },

     // "Left Card" data: contains the main title and a long description
     leftCard: {
       subtitle: "Overview of the Game",

       description: `Star Trek: Infinite is a 4X grand strategy game that puts you at the helm of one of four iconic Star Trek civilizations: the Federation, Klingons, Romulans, or Cardassians.

       The game challenges players to explore the galaxy, colonize new worlds, and engage in diplomacy, trade, or warfare with both 'Minor nations' and 'Major powers'. It weaves together scripted narrative events and emergent gameplay, allowing you to shape your interstellar empire in a way that reflects the rich lore of the Star Trek universe.

       Each faction comes with its own unique mission tree and playstyle: the Federation emphasizes exploration and diplomacy, the Klingons thrive on warfare, the Cardassians lean into espionage, and the Romulans focus on stealth tactics.

       The game also features a deep ship customization system—letting you modify vessels based on classic Star Trek designs—and includes memorable characters such as Data, Worf, Spock, and Benjamin Sisko, each contributing unique bonuses to your fleet.`,
     },

     // "Right Card" data: contains additional details (some optional)
     rightCard: {
       client: "Paradox Interactive, Nimble Giant",      // Optional: Client name
       projectType: "",                                  // Optional: Research, Indie, Professional, etc
       genre: "Grand Strategy/4X",                       // Optional: Genre of the Game (strategy, shooter, etc)
       duration: "3 Years",                              // Optional: Project duration
       completion: "",                                   // Optional: Date of completion
       state: "Released October 12th 2023",              // Optional: Project state/status

       linksSection: "Related Links",                    // Optional: Subtitle for Link List
       links:[
         { url: "https://www.paradoxinteractive.com/games/star-trek-infinite/about", text: "'Star Trek: Infinite' Website" },
         { url: "https://www.paradoxinteractive.com/", text: "Paradox Interactive" },
         { url: "https://en.wikipedia.org/wiki/Paradox_Development_Studio#Game_engines", text: "Clausewitz Engine" },
         { url: "https://nimblegiant.com/", text: "Nimble Giant Entertainment" },
       ],
     },

     // "Big Cover Image": a large cover image for the project
     bigCoverImage: {
         thumbnail: "img/projects/st_infinite/bigCoverImage.jpg",
         image: "img/projects/st_infinite/bigCoverImage.jpg",
         caption: "Concept Art of a ship battle involving all the Major Powers",
     },

     // Main Section: content for the project
     mainSection: {
      title: "Project Highlights",
      desc: "I was one of the main programmers of the game and was involved from its inception until the release. The game is based on Paradox's Clausewitz Engine and a very deep and custom scripting language of its own. I worked on many different things, but something I am really proud of is that I was in charge of learning and teaching GDs the scripting language the game uses, extending it to their needs, and making sure the game was as data-driven as possible. Here's a list of some features I worked on:",
      textItems: []
    },

     // "Custom Section": additional custom content for the project
     customSections: [
      {
        title: "Engine:",

        desc: "",

        textItems: [
         "Extended serialization and parser features, added more debugging tools, implemented geometric tests not previously available, refactored code into cleaner and modern C++ practices each time I had the opportunity, and didn't add overhead."
        ],
      },
      {
         title: "Tools/Scripting:",
       
         desc: "",
       
         textItems: [
            "Created a Scripting Helper Tool with ImGui that serves as an encyclopedia of all available triggers/effects/modifiers/etc available in your current version of the game.",
            "Created many tools for finding and fixing missing assets. Also, small PowerShell script utilities.",
            "I scripted lots of complex events, such as the Borg Crisis and many others."
         ],
       },
       {
         title: "New Systems:",
       
         desc: "",
       
         textItems: [
           "Guided Tutorial (involved many changes/extensions and a deep knowledge of the scripting features).",
           "Warp Area, Highways, Hazard Area, Neutral Zones.",
           "Empire Borders using real Geometric Collisions tests (marching squares technique, plus optimizations)",
           "We had to implement lots of Pathfinder changes and optimizations to make all the previously mentioned features work.",
           "Quest Tree. Governors and Spy Fleets, and their Missions. Job Priorities."
         ],
       },
       {
         title: "Extended Features:",
       
         desc: "",
       
         textItems: [
           "Implemented the AI for many of the new features",
           "Leaders, Techs, Modifiers, Traditions, Wars",
           "Event and Scripting Systems",
           "Added cached and multithreading improvements where possible",
           "Ship behaviors",
           "Procedural Galaxy Generation",
           "Implemented and improved many UIs (BE and FE)",
         ],
       },
     ],

     videos: [
      {
        title: "Video Overview",                          // Optional: Set to null or "" if not visible
        platform: "youtube",
        url: "https://www.youtube.com/embed/0PNry7vIs6w", // Set to null or "" if not available
      },
    ],

     // "More Images Section" (optional): an array of additional image URLs
     moreImages: [
      {
         thumbnail: "img/projects/st_infinite/gallery/Battle_thumb.jpg",
         image: "img/projects/st_infinite/gallery/Battle.jpg",
         caption:"Ship battle starting"
      },
      {
         thumbnail: "img/projects/st_infinite/gallery/Fleet_2_thumb.jpg",
         image: "img/projects/st_infinite/gallery/Fleet_2.jpg",
         caption:"Federation Fleet near a Black Hole"
      },
      {
         thumbnail: "img/projects/st_infinite/gallery/WarpArea_thumb.jpg",
         image: "img/projects/st_infinite/gallery/WarpArea.jpg",
         caption:"Warp Area Travel"
      },
      {
         thumbnail: "img/projects/st_infinite/gallery/Missions_thumb.jpg",
         image: "img/projects/st_infinite/gallery/Missions.jpg",
         caption:"Fleet Missions"
      },
      {
         thumbnail: "img/projects/st_infinite/gallery/GlobalTension_thumb.jpg",
         image: "img/projects/st_infinite/gallery/GlobalTension.jpg",
         caption:"Global Tension"
      },
      {
         thumbnail: "img/projects/st_infinite/gallery/JobPriorities_thumb.jpg",
         image: "img/projects/st_infinite/gallery/JobPriorities.jpg",
         caption:"Job Priorities"
      },
      {
         thumbnail: "img/projects/st_infinite/gallery/MissionLog_thumb.jpg",
         image: "img/projects/st_infinite/gallery/MissionLog.jpg",
         caption:"Mission Log"
      },
      {
         thumbnail: "img/projects/st_infinite/gallery/MissionTree_thumb.jpg",
         image: "img/projects/st_infinite/gallery/MissionTree.jpg",
         caption:"Mission Tree"
      },
    ]
   },

  //--------------------------------------------------------------------------------------------------------------------------
  
  // Seedworld
  {
    id: '2',

    // "Project Preview" data: used for the project overview button
    button: {
      previewImage: "img/projects/seedworld/previewImage.jpg",    // URL to preview image
      techFramework: "C++, Unreal Engine 5",                      // Technologies used
      title: "Seedworld"                                          // Project title
    },

    // "Left Card" data: contains the main title and a long description
    leftCard: {
      subtitle: "Overview of the Game",

      description: `Seedworld is a metaverse with a persistent real-world economy, where you extract resources, build blueprints, and craft items for personal use or trade. You can also earn resources by engaging with experiences created by others or reward explorers in your own creations.

      Gameplay features two main modes:

      Domination Mode:
      Experience intense multiplayer action that blends strategy, skill, and real-time decision-making. Collect resources, build fortified bases, and battle in modes like Total Domination, Team Death Match, and Free-for-All. With destructible environments, tactical building, and full-loot PvP, every match tests your tactics and reflexes.

      Creative Mode:
      Unleash your creativity without coding using easy drag-and-drop tools. Design immersive environments, customize landscapes with terraforming tools, and build your world using a rich library of assets.`,
    },

    // "Right Card" data: contains additional details (some optional)
    rightCard: {
      client: "Seedify",                                      // Optional: Client name
      projectType: "",                                        // Optional: Research, Indie, Professional, etc
      genre: "Metaverse/Sandbox/3rd Person Shooter/Creative", // Optional: Genre of the Game (strategy, shooter, etc)
      duration: "10 Months (Massive Layoffs)",                // Optional: Project duration
      completion: "",                                         // Optional: Date of completion
      state: "Unreleased",                                    // Optional: Project state/status

      linksSection: "Related Links",                          // Optional: Subtitle for Link List
      links:[
        { url: "https://seedify.fund/", text: "'Seedify' Website" },
        { url: "https://seedworld.io/", text: "'Seedworld' Website" },
        { url: "https://www.youtube.com/@SeedworldMetaverse", text: "'Seedworld' Youtube Channel" },
        { url: "https://x.com/SeedworldMeta", text: "'Seedworld' Twitter/X" },
        { url: "https://seedworldofficial.substack.com/", text: "'Seedworld' Dev Updates" },
        
      ],
    },

    // "Big Cover Image": a large cover image for the project
    bigCoverImage: {
        thumbnail: "img/projects/seedworld/bigCoverImage.jpg",
        image: "img/projects/seedworld/bigCoverImage.jpg",
        caption: "Concept Art of the 'Domination' Mode",
    },

    // Main Section: content for the project
    mainSection: {
     title: "Core Contributions & Responsibilities",

     desc: "Note: all the following features were fully networked & replicated and created natively in C++ to be extended by Blueprints using Unreal Engine 5.",
     textItems: []
   },

    // "Custom Section": additional custom content for the project
    customSections: [
     {
       title: "Plugin Architecture & Systems Development:",

       desc: "",

       textItems: [
        "We worked with a modular plugin-based architecture for better scalability and maintainability.",
        "Implemented a modular interaction system that worked with Interactable, Pickable, and Previewable Actors, leveraging Unreal's Interfaces for modularity and flexibility.",
        "Developed a networked Inventory & Crafting system using Gameplay Tags, Data Assets, UObjects, and FastTArrayReplication.",
        "Created mechanics like resource collection, item crafting, sorting, filtering, stack management, and drag-and-drop UI.",
       ],
     },

     {
      title: "Machines & Tech Unlock System:",

      desc: "",

      textItems: [
        "Designed and implemented real-time interactable machines (similar to Minecraft's crafting table), allowing players to use them collaboratively across a networked environment.",
        "Implemented a Tech Unlock System with customizable prerequisites, unlockable slots, and upgrade mechanics.",
        "Created a generic effect execution system for research/unlock events.",
      ],
    },

    {
      title: "Devices System (User Generated Content):",

      desc: "",

      textItems: [
        "Core developer of Devices, enabling players to place and configure interactive objects in real-time (similar to Fortnite Creative Mode).",
        "Defined architecture, interaction logic, replication, and UI synchronization.",
        "Developed Player Spawner, Actor Spawner, Jump Pad, and Domination Area (Control Point System).",
      ],
    },

    {
      title: "Other Gameplay Features & Utilities:",

      desc: "",

      textItems: [
        "Worked on a modular respawn system, and player overhead UI synchronization.",
        "Developed a fully networked Chest System with fixed/randomized loot and a Weighted Random Utility Class for team-wide use.",
        "Extensive use of Gameplay Tags, Gameplay Messages (Pub-Sub Design Pattern), and Gameplay Abilities.",
      ],
    },

    {
      title: "Leadership & Technical Contributions:",

      desc: "",

      textItems: [
        "Defined core architecture and best practices.",
        "Conducted interviews & technical onboarding.",
        "Wrote extensive technical documentation for internal use.",
      ],
    },
    ],
    
    videos: [
      {
        title: "Videos", // Optional: Set to null or "" if not visible
        platform: "twitter",
        url: "https://twitter.com/i/status/1859244450826121348", // Set to null or "" if not available
      },
      {
        title: "", // Optional: Set to null or "" if not visible
        platform: "youtube",
        url: "https://www.youtube.com/embed/iW1bs2cpnyE", // Set to null or "" if not available
      },
      {
        title: "", // Optional: Set to null or "" if not visible
        platform: "youtube",
        url: "https://www.youtube.com/embed/eUohwzEDaBM", // Set to null or "" if not available
      },
    ],

    // "More Images Section" (optional): an array of additional image URLs
    moreImages: [
      /*
     {
        thumbnail: "img/projects/st_infinite/gallery/Battle_thumb.jpg",
        image: "img/projects/st_infinite/gallery/Battle.jpg",
        caption:"Ship battle starting"
     },
     {
        thumbnail: "img/projects/st_infinite/gallery/Fleet_2_thumb.jpg",
        image: "img/projects/st_infinite/gallery/Fleet_2.jpg",
        caption:"Federation Fleet near a Black Hole"
     },
     {
        thumbnail: "img/projects/st_infinite/gallery/WarpArea_thumb.jpg",
        image: "img/projects/st_infinite/gallery/WarpArea.jpg",
        caption:"Warp Area Travel"
     },
     {
        thumbnail: "img/projects/st_infinite/gallery/Missions_thumb.jpg",
        image: "img/projects/st_infinite/gallery/Missions.jpg",
        caption:"Fleet Missions"
     },
     {
        thumbnail: "img/projects/st_infinite/gallery/GlobalTension_thumb.jpg",
        image: "img/projects/st_infinite/gallery/GlobalTension.jpg",
        caption:"Global Tension"
     },
     {
        thumbnail: "img/projects/st_infinite/gallery/JobPriorities_thumb.jpg",
        image: "img/projects/st_infinite/gallery/JobPriorities.jpg",
        caption:"Job Priorities"
     },
     {
        thumbnail: "img/projects/st_infinite/gallery/MissionLog_thumb.jpg",
        image: "img/projects/st_infinite/gallery/MissionLog.jpg",
        caption:"Mission Log"
     },
     {
        thumbnail: "img/projects/st_infinite/gallery/MissionTree_thumb.jpg",
        image: "img/projects/st_infinite/gallery/MissionTree.jpg",
        caption:"Mission Tree"
     },
     */
   ]
  },

  //--------------------------------------------------------------------------------------------------------------------------
  
];

export default Projects;